import React, { useEffect, useState } from "react";
import { axiosSalary } from "../api/axiosInstance";
import { useAuth } from "../auth/AuthContext";

const EditSessionByManager = ({ open, onClose, rowData, onSuccess }) => {

  const { user } = useAuth();

  const [sessions, setSessions] = useState([]);
  const [form, setForm] = useState({
    sessionId: "",
    inTime: "",
    outTime: "",
    reason: ""
  });

  /* ================= IST → INPUT FORMAT ================= */
  const convertISTToInput = (istString) => {
    if (!istString) return "";

    const [datePart, timePart, modifier] = istString.split(" ");
    const [day, month, year] = datePart.split("/");
    let [hours, minutes] = timePart.split(":");

    hours = parseInt(hours);

    if (modifier === "PM" && hours !== 12) hours += 12;
    if (modifier === "AM" && hours === 12) hours = 0;

    return `${year}-${month}-${day}T${String(hours).padStart(2, "0")}:${minutes}`;
  };

  /* ================= DATE FORMAT ================= */
  const formatDate = (dateStr) => {
    const datePart = dateStr.split(" ")[0];
    return new Date(
      datePart.split("/").reverse().join("-")
    ).toISOString();
  };

  /* ================= FETCH ALL SESSIONS ================= */
  useEffect(() => {
    const fetchAttendance = async () => {
      try {
        const res = await axiosSalary.get(
          `/DailyAttendance/GetAttendanceForManagerEdit`,
          {
            params: {
              groupId: user?.groupId,
              restId: rowData?.restId,
              empId: rowData?.empId,
              attendanceDate: formatDate(rowData.attendanceDate),
            },
          }
        );

        setSessions(res.data?.sessions || []);

      } catch (err) {
        console.error("Fetch error:", err);
      }
    };

    if (open && rowData) {
      fetchAttendance();
      setForm({
        sessionId: "",
        inTime: "",
        outTime: "",
        reason: ""
      });
    }
  }, [open, rowData, user]);

  /* ================= SELECT SESSION ================= */
  const handleSelect = (s) => {
    setForm({
      sessionId: s.sessionId,
      inTime: convertISTToInput(s.inTimeIst),
      outTime: s.outTimeIst ? convertISTToInput(s.outTimeIst) : "",
      reason: ""
    });
  };

  /* ================= SUBMIT ================= */
  const handleSubmit = async () => {

    if (!form.sessionId) {
      alert("Select session first");
      return;
    }

    if (!form.inTime || !form.outTime) {
      alert("Enter in/out time");
      return;
    }

    if (new Date(form.outTime) <= new Date(form.inTime)) {
      alert("Out time must be greater");
      return;
    }

    try {

      const payload = {
        groupId: user?.groupId,
        restId: rowData.restId,
        empId: rowData.empId,

        attendanceDate: formatDate(rowData.attendanceDate),

        session: {
          sessionId: form.sessionId,
          inTimeUtc: new Date(form.inTime).toISOString(),
          outTimeUtc: new Date(form.outTime).toISOString(),
        },

        userId: user?.userId,
        reason: form.reason
      };

      await axiosSalary.post(
        "/DailyAttendance/ReplaceSessionByManager",
        payload
      );

      alert("Session updated successfully");

      onClose();
      onSuccess && onSuccess();

    } catch (err) {
      console.error(err);
      alert("Failed to update session");
    }
  };

  if (!open) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">

      <div className="bg-white rounded-lg p-4 w-[360px] max-h-[80vh] overflow-auto">

        <h3 className="font-semibold mb-3">
          Edit Session - {rowData?.empName}
        </h3>

        {/* SESSION LIST */}
        <div className="space-y-2 mb-3">
          {sessions.map((s) => (
            <div
              key={s.sessionId}
              onClick={() => handleSelect(s)}
              className={`p-2 border rounded text-xs cursor-pointer ${
                form.sessionId === s.sessionId
                  ? "bg-blue-100 border-blue-400"
                  : "hover:bg-gray-100"
              }`}
            >
              <div>In: {s.inTimeIst}</div>
              <div>Out: {s.outTimeIst || "Open"}</div>
            </div>
          ))}
        </div>

        {/* FORM */}
        {form.sessionId && (
          <div className="space-y-2 text-sm">

            <input
              type="datetime-local"
              value={form.inTime}
              onChange={(e) =>
                setForm({ ...form, inTime: e.target.value })
              }
              className="w-full border p-2 rounded"
            />

            <input
              type="datetime-local"
              value={form.outTime}
              onChange={(e) =>
                setForm({ ...form, outTime: e.target.value })
              }
              className="w-full border p-2 rounded"
            />

            <textarea
              placeholder="Reason"
              value={form.reason}
              onChange={(e) =>
                setForm({ ...form, reason: e.target.value })
              }
              className="w-full border p-2 rounded"
            />

          </div>
        )}

        {/* ACTION */}
        <div className="flex justify-end gap-2 mt-3">

          <button
            onClick={onClose}
            className="px-3 py-1 border rounded"
          >
            Cancel
          </button>

          <button
            onClick={handleSubmit}
            className="px-3 py-1 bg-green-600 text-white rounded"
          >
            Update
          </button>

        </div>

      </div>

    </div>
  );
};

export default EditSessionByManager;